<template lang="pug">
v-main
  v-container(fluid)
    v-flex
        v-card.pt-2
            v-text-field.col-12(
                flat
                append-icon="search"
                placeholder="Keyword (optional)"
                v-model="keyword"
                hide-details
            )

            v-data-table.elevation-1(
                :headers="im.headers"
                :items="im.items"
                :search="keyword"
                :loading="loading"
                class="no-hover-table"

            )
                template(v-slot:item="props")
                    <tr>
                        <td class="maininfo">
                          a(:href="props.item.link_qr.link" target="_blank") {{ props.item.imNo }}
                        </td>
                        <td class="maininfo">{{ getUTC7Date(props.item.imDate) }}</td>
                        <td class="maininfo">{{ props.item.imUser.name }}</td>
                        <td class="maininfo">{{ props.item.imUser.email }}</td>
                        <td class="maininfo">{{ props.item.imOrganization.name }}</td>
                        <td class="maininfo">{{ props.item.imPerihal }}</td>
                        <td class="maininfo">
                            img(:src="'data:image/png;base64, '+props.item.link_qr.qrcode" style="vertical-align:middle;width:150px;")
                        </td>
                    </tr>
                    <tr>
                        <td colspan="7" class="extend">
                            strong Usulan:
                            div(v-html="props.item.imUsulan" class="ck-content")
                        </td>
                    </tr>
</template>

<script>
export default {
  name: "IMListBOD",
  props: {
    im: Object,
    loading: Boolean,
  },
  data() {
    return {
      keyword: "",
    };
  },
  methods: {
    getUTC7Date(tgl) {
      let tanggal = new Date(tgl);
      let month =
        tanggal.getMonth() + 1 < 10
          ? "0" + (tanggal.getMonth() + 1)
          : tanggal.getMonth() + 1;
      let date =
        tanggal.getDate() < 10 ? "0" + tanggal.getDate() : tanggal.getDate();
      return tanggal.getFullYear() + "-" + month + "-" + date;
    },
  },
};
</script>

<style scoped>
table td.maininfo {
  border-bottom: none !important;
}

.no-hover-table >>> tr:hover {
  background: transparent !important;
}
</style>
